
    import * as React from 'react';

    const Expand12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M6.375 6.375V11h-.75V6.375H1v-.75h4.625V1h.75v4.625H11v.75H6.375z" /></svg>
        </div>
      );
    };

    Expand12.displayName = 'Expand12';

    export default Expand12;
  